import React from 'react';
import IMark from 'assets/images/global/svg/ic_place_bold_b.inline.svg';
import IHomeFill from 'assets/icons/ic_home_fill.inline.svg';

const Mark = ({ lat, lng }) => {
  return (
    <div>
      <IMark lat={lat} lng={lng} />
      {lat === 4.675612127947397 && lng === -74.0467914684936 && (
        <div className="bold-house-icon">
          <IHomeFill lat={lat} lng={lng} />
        </div>
      )}
    </div>
  );
};

export default Mark;
